const article = {
	slug: "unplugged-clarity-half-marathon",
	title: "Unplugged Clarity: The Perspective I Did Not Know I Needed",
	date: "March 2025",
	updated: null,
	description: "Running a half marathon without headphones became a lesson in presence and being more intentional about technology.",
	keywords: ["presence", "digital wellbeing", "running", "half marathon"],
	tldr: "Sometimes the technological crutches we lean on, headphones, social media, constant note taking, quietly disconnect us from what is happening right in front of us.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, March 2025.",
	provenanceUrl: null,
	series: null,
	artifact: null,
	markdown: `I had a mental block.

I used to believe that I could not run and workout without music or podcasts. Like, physically impossible. My brain needed the distraction, my legs needed the beat.

## The race that changed my mind

Last week, I had the privilege of completing the NYC Half Marathon. The well known NYC energy in the air, the cheering crowds along the streets, conversations with fellow runners from all over the world, and my labored breathing created an unexpected soundtrack.

There was something historically surreal about running through both Times Square and the Brooklyn Bridge, closed together for the first time ever.

I had planned to enjoy the initial atmosphere before reverting to my headphones at the 5K mark. But those 5K turned into 10K, then 15K, and eventually the full 21K as the morning city vibes completely absorbed me.

## Where else I was missing the moment

This "unplugged" race experience made me reflect on other areas of my life where I might be missing the moment.

It reminded me of when one of my senior colleagues at work recently called me out for excessive note-taking in meetings. "You're missing what's actually happening while trying to document everything," she pointed out. That was eye-opening.

I had embraced Tiago Forte's "Building a Second Brain" methodology perhaps too enthusiastically, focusing on capturing everything at the expense of being present. Similarly, since uninstalling Instagram, I have reclaimed a lot of mental space and productivity that I never realized was being consumed.

This experience reminded me that sometimes technological crutches, whether headphones, social media, or constant note taking are disconnecting me from fully experiencing what's happening around me.

## Being intentional, not absolute

Not saying I will throw away my headphones or stop taking notes altogether, but will be more intentional about when to use technology, and when to simply be present.

*"Almost everything will work again if you unplug it for a few minutes, including you."*

Anne Lamott`,
};

export default article;
